import React from "react";
import BaseApi from "../../../utils/BaseApi";
import {CircularProgress, Modal, ModalClose, ModalDialog} from "@mui/joy";
import Box from "@mui/joy/Box";

// icons
import CommonForm from "../../Common/CommonForm";
import Typography from "@mui/joy/Typography";
import EditIcon from '@mui/icons-material/Edit';
import Link from "@mui/joy/Link";
import {deleteArrayItemByKeyValue} from "../../../utils/misc";


class RouteAgentCallUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            formFields: null,
            success: false,
        };
    }

    async componentDidMount(){
        await this.retrieveForm();
        await this.retrieveAgentCallProcesses();
    }

    async retrieveForm(){
        const url = `route_stage_agent_call/update_form/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        let formFields = response.data
        formFields = deleteArrayItemByKeyValue(
            formFields,
            'name',
            'stage'
        );
        let formObj = this.props.obj
        formObj.agent = this.props.obj.agent.id
        this.setState(
            {
                formFields: formFields,
                formObj: formObj
            }
        );
    }

    async retrieveAgentCallProcesses() {
        const url = `route_stage_agent_call_process/`;
        const api = new BaseApi();
        const params = {
            route_stage_agent_call: this.props.obj.id
        };
        let response = await api.get(url, params);
        this.setState(
            {
                agent_processes: response.data.results
            }
        )
    }

    async setModalOpenTrue(){
        await this.setState({
            modalOpen: true,
        })
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        formDataObj.params = JSON.parse(formDataObj.params)
        const url = `route_stage_agent_call/${this.props.obj.id}/`;
        const api = new BaseApi();
        let response = await api.patch(
            url,
            formDataObj
        );
        if (response.status === 200) {
            this.setState(
                {
                    formObj: response.data
                }
            )
            // await this.setModalOpenFalse();
        }
        return response
    }

    async setModalOpenFalse() {
        this.setState(
            {
                modalOpen: false,
            }
        );
        await this.props.callBack();
    }

    render() {
        if (!this.state.formFields || !this.state.agent_processes){
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'inline'
                }}
            >
                <Link
                    level="body-xs"
                    color={'primary'}
                    onClick={this.setModalOpenTrue.bind(this)}
                >
                    <EditIcon/>
                </Link>
                <Modal
                    open={this.state.modalOpen}
                >
                    <ModalDialog
                        layout={'center'}
                        size="sm"
                    >
                        <ModalClose
                            onClick={this.setModalOpenFalse.bind(this)}
                        />
                        <Box
                            sx={{
                                overflowY: 'scroll',
                                width: 'calc(80vw)',
                                height: 'calc(80vh)',
                                pr: 2
                            }}
                        >
                            <Typography
                                level={'h2'}
                                sx={{mb: 2}}
                            >
                                Редактирование вызова агента
                            </Typography>
                            <CommonForm
                                fields={this.state.formFields}
                                processForm={this.processForm.bind(this)}
                                object={this.state.formObj}
                            />
                        </Box>
                    </ModalDialog>
                </Modal>
            </Box>
        )
    }
}

export default RouteAgentCallUpdate
